import React from "react";
import { Instagram, Linkedin, Mail, ArrowUpRight, Building2 } from "lucide-react";
import { NAV_LINKS } from "../../data/content";

const XIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16" {...props}>
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.66l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.45-6.231Zm-1.161 17.52h1.833L7.084 4.126H5.117l11.966 15.644Z" />
  </svg>
);

const SOCIALS = [
  { label: "Instagram", href: "https://www.instagram.com/amiran_azaladze/", Icon: Instagram },
  { label: "LinkedIn", href: "https://www.linkedin.com/in/amirani/", Icon: Linkedin },
  { label: "X", href: "https://x.com/AmiranAzaladze", Icon: XIcon },
  { label: "Crunchbase", href: "https://www.crunchbase.com/person/amiran-azaladze", Icon: Building2 },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative z-10 border-t border-white/[0.07] bg-[#0c0c0b]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-20 pb-10">
        <div className="grid gap-12 lg:grid-cols-12">
          {/* Brand + CTA */}
          <div className="lg:col-span-5">
            <div className="font-display text-2xl font-bold tracking-[0.06em] mb-4">
              AMIRAN <span className="text-amber">AZALADZE</span>
            </div>
            <p className="text-ink-secondary leading-relaxed max-w-sm mb-6">
              Entrepreneur & business leader building ventures that matter — SaaS, fintech, and service companies
              operating worldwide.
            </p>
            <a
              href="#contact"
              data-testid="footer-cta"
              className="group inline-flex items-center gap-2 rounded-full bg-amber px-6 py-3 text-sm font-semibold uppercase tracking-[0.12em] text-obsidian hover:bg-amber-hover transition-colors duration-300"
            >
              Start a Conversation
              <ArrowUpRight size={16} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300" />
            </a>
          </div>

          {/* Navigate */}
          <div className="lg:col-span-3">
            <div className="text-[0.7rem] uppercase tracking-[0.18em] text-ink-muted mb-5">Navigate</div>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-ink-secondary hover:text-amber transition-colors duration-300"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Connect */}
          <div className="lg:col-span-4">
            <div className="text-[0.7rem] uppercase tracking-[0.18em] text-ink-muted mb-5">Connect</div>
            <a
              href="mailto:a.azaladze@menelausholding.com"
              data-testid="footer-email"
              className="group inline-flex items-center gap-3 text-ink hover:text-amber transition-colors duration-300 mb-6"
            >
              <span className="h-10 w-10 rounded-lg border border-white/10 flex items-center justify-center text-amber group-hover:border-amber/40 transition-colors duration-300">
                <Mail size={16} />
              </span>
              <span className="break-all">a.azaladze@menelausholding.com</span>
            </a>
            <div className="flex items-center gap-3">
              {SOCIALS.map(({ label, href, Icon }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  data-testid={`social-${label.toLowerCase()}`}
                  className="h-11 w-11 rounded-full border border-white/10 flex items-center justify-center text-ink-secondary hover:text-obsidian hover:bg-amber hover:border-amber transition-colors duration-300"
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-6 border-t border-white/[0.07] flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-sm text-ink-muted">
            © {new Date().getFullYear()} Amiran Azaladze. All rights reserved.
          </div>
          <div className="flex items-center gap-6 text-sm">
            <span className="text-ink-muted">Worldwide</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
